const loadedLevelsReducer = (levels = [], action) => {
    switch(action.type){
        case 'SET_LEVELS':
            levels = action.data
            return levels;
        case 'ADD_LEVELS':
            let newLevels = action.data
            return [...levels, ...newLevels];
        default:
            return levels;
    }
}

export default loadedLevelsReducer